module.exports = __webpack_public_path__ + "img/logo3.1393e654.png";